var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (missing, options, sequence, undefined) {
// iterate options
;(function(){
  var $$obj = options;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var image = $$obj[i];

buf.push("<div class=\"btn-image-container block-md\"><img" + (jade.attr("src", image, true, false)) + (jade.attr("data-is-correct", image === sequence[missing[0]], true, false)) + (jade.cls(['btn-image',"delay-" + (i) + ""], [null,true])) + "/></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var image = $$obj[i];

buf.push("<div class=\"btn-image-container block-md\"><img" + (jade.attr("src", image, true, false)) + (jade.attr("data-is-correct", image === sequence[missing[0]], true, false)) + (jade.cls(['btn-image',"delay-" + (i) + ""], [null,true])) + "/></div>");
    }

  }
}).call(this);
}.call(this,"missing" in locals_for_with?locals_for_with.missing:typeof missing!=="undefined"?missing:undefined,"options" in locals_for_with?locals_for_with.options:typeof options!=="undefined"?options:undefined,"sequence" in locals_for_with?locals_for_with.sequence:typeof sequence!=="undefined"?sequence:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}